import { memo, ReactNode } from 'react'
import cn from 'classnames'
import { FieldLabel } from 'components/extend/FieldLabel'

import s from './FieldWrapper.module.less'

interface IProps {
  children?: ReactNode
  className?: string
  htmlFor?: string
  info?: string
  label?: ReactNode
  labelClassName?: string
  noPadding?: boolean
  type?: 'horizontal' | 'vertical'
}

export const FieldWrapper = memo(function FieldWrapper({
  children,
  className,
  label,
  labelClassName = '',
  type = 'vertical',
  noPadding,
  htmlFor,
  info
}: IProps) {
  return (
    <div className={cn(s[type], className, noPadding && s.noPadding)}>
      {label && (
        <div className={cn(s.label, labelClassName)}>
          {typeof label === 'string' ? (
            <FieldLabel htmlFor={htmlFor} info={info}>
              {label}
            </FieldLabel>
          ) : (
            label
          )}
        </div>
      )}
      <div className={s.field}>{children}</div>
    </div>
  )
})
